import React, { useState, useEffect, useContext, useRef } from "react";
import makeStyles from '@mui/styles/makeStyles';
import { useParams } from "react-router-dom";
import swal from "sweetalert";
import PrescriptionForm from "./PrescriptionForm";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import * as api from "../../../actions/api";
import { useTranslation } from "react-i18next";
import { UserContext } from "../../../context/user-info-context";



const AddPrescription = (props) => {
  
  const userCtx = useContext(UserContext);
  // const lan = userCtx.userInfo.LangId; //"fr_FR";
  const DispensingLanguage = JSON.parse(
    localStorage.getItem("DispensingLanguage")
  ); //get DispensingLanguage
  const menukey = "prescriptions";

  const lan = localStorage.getItem("LangCode");
  // const lan = "fr_FR";
  const { t, i18n } = useTranslation();

  const queryClient = useQueryClient();
  let id = null;
  if (window.location.href.split("/").length) {
    id =
      window.location.href.split("/")[
        window.location.href.split("/").length - 1
      ];
  }

  const [controlLoading,setControlLoading] = useState(false);
  const saveInFlightRef = useRef(false);
  // const { data } = useQuery(['patient', id], () =>
  //   api.getPatient(id).then((res) => {
  //     setPatientData(res.data);
  //     setFormData({ ...formData, patientId: res.data.id });
  //     return res.data
  //   }), {
  //   enabled: Boolean(id)
  // })

  const { data } = useQuery(
    ["patient", id],
    () =>
      api.getPatient(id).then((res) => {
        setPatientData(res.data);
        // console.log("id: ", id);
        // console.log("Get patient list from AddPrescription.js: ", res.data);
        setFormData({
          ...formData,
          patientId: res.data.id,
          firstName: res.data.firstName,
          lastName: res.data.lastName,
          // patientIdNumber: res.data.idNumber,
          patientIdNumber: res.data.pass,
          ipn: res.data.ipn,
          idNumber: res.data.idNumber,

          ExistingProtocolId:  res.data.ExistingProtocolId,
          // RegimenId:  res.data.RegimenId,

        });
        return res.data;
      }),
    {
      refetchOnWindowFocus: false,
      enabled: Boolean(id),
    }
  );


  const { isLoading: isSaveMutating, mutate } = useMutation(api.savePrescription, {
    onSuccess: (data) => {

      if (data.success === 1) {
        // swal("Success!", "", "success");
        
        props.openNoticeModal({
          isOpen: true,
          msg: data.message,
          msgtype: data.success,
        });

        queryClient.getQueriesData("prescription");
        props.history.push("/prescription");

      }else{

        props.openNoticeModal({
          isOpen: true,
          msg: data.message,
          msgtype: data.success,
        });

        // swal(
        //   data.message,
        //   {
        //     icon: "error",
        //   }
        // );
      }


    },
  });

  const [patientData, setPatientData] = useState({
    id: "",
    productCode: "",
    productName: "",
    icn: "",
    genericName: "",
    tradeName: "",
    ecn: "",
    strengthSize: "",
    price: "",
    ven: "",
    nsn: "",
    form: "",
    routeOfAdmin: "",
    abc: "",
    fin: "",
    packSize: "",
    unit: "",
    atc: "",
    rxLevel: "",
    productType: "",
    administrationUnit: "",
    pediatric: false,
    injectable: false,
    binLocation: "",
    markUp: "",
    sellingPrice: "",
    shippingPack: "",
    productDescription: "",
    includeTradenameinDescription: false,
    excludeGenericnamefromDescription: false,
    availableforDispensing: false,
    breakAdministrationUnit: false,
  });

  const generatePrescriptionId = () => {
    var result = "";
    let firstPlace = "";
    let secondPlace = "";
    var characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    var charactersLength = characters.length;
    for (var i = 0; i < 2; i++) {
      firstPlace += characters.charAt(
        Math.floor(Math.random() * charactersLength)
      );
    }
    var numbers = "0123456789";
    var numbersLength = numbers.length;
    for (var i = 0; i < 8; i++) {
      secondPlace += numbers.charAt(Math.floor(Math.random() * numbersLength));
    }

    result =
      firstPlace + "/" + secondPlace + "/" + Math.floor(Math.random() * 10);
    return result;
  };

  const [errorObject, setErrorObject] = useState({});
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [selectedProtocols, setSelectedProtocols] = useState([]);
  const [showProductListModel, setShowProductListModel] = useState(false);
  const [showProtocolListModel, setShowProtocolListModel] = useState(false);

  const IntervalList = JSON.parse(localStorage.getItem("IntervalList"));
  const FacilityId = localStorage.getItem("FacilityId");

  const [formData, setFormData] = useState({
    id: "",
    demander: FacilityId,
    prescriber: "",
    ClinicId: "",
    dispenser: "",
    patientId: "",
    prescriptionDate: "",//new Date(),
    appointmentDate: null,
    prescriptionNumbar: generatePrescriptionId(),
    patientIdNumber: "",
    ipn: "",
    idNumber: "",
    firstName: "",
    lastName: "",
    referred: false,
    new: false,
    pregnant: false,
    status: -1,
    ICDCode: "",
    cost: 0,
    finalCost: 0,
    packs: "",
    batchId: "",
    details: [],
    repeats: 0,
    ProtocolId: "",
    RegimenId: "",
    ExistingProtocolId: "",
    deletedDataSet: "",
    MaxDur: "",
    ProductTypeId: "",
    Remarks: "",
    RepeatFromPrescriptionId:"",
    currentDate: new Date(),
  });

  const handleDateChange = (date) => {};

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });

    setErrorObject({ ...errorObject, [name]: null });
  };

  const handleDetailChange = (e, rowData) => {
    let data = { ...formData };
    let details = [...formData.details];
    const { name, value } = e.target;

    details = details.map((detail) => {
      if (detail.id == rowData.id) {
        detail[name] = value;
      }
      return detail;
    });
    data["details"] = details;
    setFormData(data);
  };

  const handleDetailDropDownChange = (e, rowData) => {
    console.log(
      "Product before update rows when dropdown change in add page: ",
      rowData
    );
    let data = { ...formData };
    let details = [...formData.details];
    const { name, value } = e.target;

    details = details.map((detail) => {
      if (detail.id == rowData.id) {
        detail[name] = value;
        // console.log("IntervalList: ",IntervalList);
        // console.log("cur intervalId: ",rowData.intervalId);

        const curInvervalValueObj = IntervalList.filter((intervalRow) => {
          if (rowData.intervalId == intervalRow.id) {
            return intervalRow;
          }
        });
        // console.log("curInvervalValueObj: ",curInvervalValueObj);
        // console.log("curInvervalValue: ",curInvervalValueObj[0].value);

        let calcQty =
          detail["dur"] * curInvervalValueObj[0].value * detail["qty"];
        detail["calc"] = calcQty;

        // let tmpPcks = Math.ceil(calcQty/detail['PacksizeName']);
        // detail['pcks'] = tmpPcks;
        // detail['dispQty'] = tmpPcks*detail['PacksizeName'];
      }
      return detail;
    });
    console.log(
      "Product updated rows when dropdown change in add page: ",
      details
    );
    data["details"] = details;
    setFormData(data);
  };

  const handleDetailCheck = (e, rowData) => {
    let data = { ...formData };
    let details = [...formData.details];
    const { name, checked } = e.target;

    details = details.map((detail) => {
      if (detail.id == rowData.id) {
        detail[name] = checked;
      }
      return detail;
    });
    data["details"] = details;
    setFormData(data);
  };

  const setUpdatedDetailsGridDataHandler = (rows, curcol) => {
    if (curcol === "qty" || curcol === "dur" || curcol === "pcks") {
      console.log("Product before updated rows in add page: ", rows);
      console.log("Edited column: ", curcol);

      let data = { ...formData };
      let ManyTableData = data["details"];

      const updateManyTableData = ManyTableData.map((row) => {
        // if (row.SKU == rows.SKU) {
        if (row.id == rows.id) {
          if (curcol === "qty" || curcol === "dur") {
            console.log("IntervalList: ", IntervalList);
            console.log("cur intervalId: ", rows.intervalId);

            const curInvervalValueObj = IntervalList.filter((intervalRow) => {
              if (rows.intervalId == intervalRow.id) {
                return intervalRow;
              }
            });
            console.log("curInvervalValueObj: ", curInvervalValueObj);
            console.log("curInvervalValue: ", curInvervalValueObj[0].value);

            row.qty = rows.qty;
            row.dur = rows.dur;
            row.rep = rows.rep;
            let calcQty = rows.dur * curInvervalValueObj[0].value * rows.qty;
            row.calc = calcQty;

            // let tmpPcks = Math.ceil(calcQty/rows.PacksizeName);
            // row.pcks = tmpPcks;
            // row.dispQty = tmpPcks*rows.PacksizeName;
          } else if (curcol === "pcks") {
            let calDispQty = "";
            if (rows.pcks > 0) {
              calDispQty = rows.PacksizeName * rows.pcks;
            }
            row.dispQty = calDispQty;
          }
        }

        return row;
      });
      data["details"] = updateManyTableData;

      console.log("Product updated rows in add page: ", updateManyTableData);
      setFormData(data);
    }
  };

  const handleProductAdd = (NonOrderProductData) => {
    let data = { ...formData };

    data["details"] = NonOrderProductData;
    setFormData(data);
    // setManyTableData(NonOrderProductData)
  };

  const handleCheck = (e) => {
    const { name, checked } = e.target;
    setFormData({ ...formData, [name]: checked });
  };

  const handleRDateChange = (date, field) => {
    setFormData({ ...formData, [field]: date });
    setErrorObject({ ...errorObject, [field]: null });
  };

  const handleReset = () => {

    // setFormData({
    //   ...formData,
    //   patientId: res.data.id,
    //   firstName: res.data.firstName,
    //   lastName: res.data.lastName,
    //   patientIdNumber: res.data.idNumber,
    // });

    setFormData({
      ...formData,
      id: "",
      demander: FacilityId,
      prescriber: "",
      ClinicId: "",
      dispenser: "",
      // patientId: "",
      prescriptionDate: "",// new Date(),
      appointmentDate: null,
      prescriptionNumbar: generatePrescriptionId(),
      // patientIdNumber: "",
      referred: false,
      new: false,
      pregnant: false,
      status: -1,
      ICDCode: "",
      cost: 0,
      finalCost: 0,
      packs: "",
      batchId: "",
      details: [],
      repeats: 0,
      ProtocolId: "",
      RegimenId: "",
      //ExistingProtocolId: "",
      deletedDataSet: "",
      MaxDur: "",
      Remarks: "",
      RepeatFromPrescriptionId:"",
      currentDate: new Date(),
    });
  };

  const validateForm = (formData) => {
    let validateFields = ["dispenser", "prescriber", "prescriptionDate"];
    let errorData = {};
    let isValid = true;
    validateFields.map((field) => {
      if (!formData[field]) {
        errorData[field] =
          t(DispensingLanguage[lan][menukey]["field is Required !"]);
        isValid = false;
      }
    });
    setErrorObject(errorData);
    return isValid;
  };

  const handleSubmit = async (e) => {
    if (saveInFlightRef.current || isSaveMutating) {
      return;
    }
    let data = { ...formData };

    if (validateForm(formData)) {
      if(formData.details.length === 0){
        // swal(
        //   t(DispensingLanguage[lan][menukey]["There are no prescription details"]),
        //   {
        //     icon: "error",
        //   }
        // );

        props.openNoticeModal({
          isOpen: true,
          msg:  t(DispensingLanguage[lan][menukey]["There are no prescription details"]),
          msgtype: 0,
        });

      }else{
        saveInFlightRef.current = true;
        setControlLoading(true);
        mutate(data, {
          onSettled: () => {
            saveInFlightRef.current = false;
            setControlLoading(false);
          },
        });
      }
    }
  };

  useEffect(() => {}, [formData]);

  return (
    <PrescriptionForm
      setFormData={setFormData}
      AddRecord={true}
      patientData={patientData}
      formData={formData}
      handleChange={handleChange}
      handleDateChange={handleDateChange}
      handleCheck={handleCheck}
      handleSubmit={handleSubmit}
      handleReset={handleReset}
      handleRDateChange={handleRDateChange}
      showProductListModel={showProductListModel}
      setShowProductListModel={setShowProductListModel}
      // productList={getProductsMutate.data}
      // protocolList = {getProtocolMutate.data}
      handleDetailChange={handleDetailChange}
      handleDetailDropDownChange={handleDetailDropDownChange}
      handleDetailCheck={handleDetailCheck}
      selectedProducts={selectedProducts}
      setSelectedProducts={setSelectedProducts}
      selectedProtocols={selectedProtocols}
      setSelectedProtocols={setSelectedProtocols}
      showProtocolListModel={showProtocolListModel}
      setShowProtocolListModel={setShowProtocolListModel}
      errorObject={errorObject}
      productAdd={handleProductAdd}
      setUpdatedDetailsGridDataHandler={setUpdatedDetailsGridDataHandler}
      controlLoading={controlLoading}
      permissionType={props.permissionType}
      {...props}
      isSubmitting={isSaveMutating}
    />
  );
};

export default AddPrescription;

const useStyles = makeStyles({
  productPageTitle: {
    marginTop: "60px",
    color: "white",
    padding: "10px",
  },
  tableContainer: {
    backgroundColor: "whitesmoke",
    borderRadius: "10px",
    padding: "2rem",
    color: "black",
  },
  fullWidth: {
    width: "100%",
  },
  th: {
    "border-left": "1px solid red",
  },
});
